import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { removeActionTypes }    from 'Utils/ReducerUtility';
import { IAppUserState }        from 'Redux/Slices/AppUser/AppUserSlice';

export const findAppUserEventsRequest = (state: Draft<IAppUserState>, { type, payload }: PayloadAction<{ userId: string, organisationId: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  // Clear this organisation's assignment immediately, so a stale set can't be sent along
  // if the admin assigns an event before this fetch resolves.
  state.assignedEventIdsByOrganisation[payload.organisationId] = [];
  state.updatedAt = Date.now();
};

export const findAppUserEventsSuccess = (state: Draft<IAppUserState>, { type, payload }: PayloadAction<{ organisationId: string, eventIds: string[] }>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.assignedEventIdsByOrganisation[payload.organisationId] = payload.eventIds;
};

export const findAppUserEventsFailure = (state: Draft<IAppUserState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
